export default (event: EventDate) => {
    return new Date(useRuntimeConfig().public.showEventDatePriceFrom as string) < new Date(event.start_date);
};
